import TopbarAction from '@/components/TopbarAction'
import { useTranslation } from 'react-i18next'
import { BellRing, BellOff, Bell } from 'lucide-react'
import useNotificationStore from '@/stores/useNotificationStore'
import { useAppStore } from '@/stores/useAppStore'
import { useNotifications } from '../../hooks/useNotifications'

export type { NotificationItem } from '../../hooks/useNotifications'

/** Topbar bell; the list itself opens in the docked side panel. */
const NotificationComp = () => {
    const { notificationPermissionStatus } = useNotificationStore()
    const sidePanel = useAppStore((state) => state.sidePanel)
    const toggleSidePanel = useAppStore((state) => state.toggleSidePanel)
    const { t } = useTranslation()
    const { notSeenCount, markSeen } = useNotifications(10)

    const handleToggle = () => {
        if (notificationPermissionStatus !== 'granted') {
            return Notification.requestPermission()
        }

        toggleSidePanel('notifications')
        markSeen()
    }

    const isGranted = notificationPermissionStatus === 'granted'
    // Without permission the click asks for it, so the label says that.
    const label = isGranted ? t('notification') : t('notification.enable')

    const BellIcon = !isGranted ? BellOff : notSeenCount <= 0 ? BellRing : Bell

    return (
        <TopbarAction
            icon={BellIcon}
            aria-label={label}
            aria-pressed={sidePanel === 'notifications'}
            onClick={handleToggle}
        />
    )
}

export default NotificationComp
